import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ obtidas, total, showLabel = true, size = 'normal', showMarkers = true }) => {
  const pct = total > 0 ? Math.round((obtidas / total) * 100) : 0;

  const generateMarkers = () => {
    if (!showMarkers || total <= 0) return [];

    const markers = [];
    const quarterPoints = [0, 0.25, 0.5, 0.75, 1];

    quarterPoints.forEach((point) => {
      const value = Math.round(total * point);
      const isLastMarker = point === 1;
      markers.push({
        value,
        position: point * 100,
        isLast: isLastMarker,
      });
    });

    return markers;
  };

  const markers = showMarkers ? generateMarkers() : [];

  return (
    <div className={`progress-bar-wrap ${size}`}>
      {showLabel && (
        <div className="progress-bar-label">
          <span>{obtidas}/{total}</span>
          <span>{pct}%</span>
        </div>
      )}
      <div className="progress-bar-container">
        <div className="progress-bar-track">
          <div
            className="progress-bar-fill"
            style={{ width: `${pct}%` }}
            role="progressbar"
            aria-valuenow={obtidas}
            aria-valuemin={0}
            aria-valuemax={total}
          />
        </div>
        {showMarkers && markers.length > 0 && (
          <div className="progress-bar-markers">
            {markers.map((marker, idx) => (
              <div
                key={idx}
                className={`marker ${marker.isLast ? 'marker-last' : ''}`}
                style={{ left: `${marker.position}%` }}
              >
                <span className="marker-value">{marker.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
